import { COMMENT_TEXT_LIMIT, measureReplyText, type ReplyTextLimit, type ReplyTextUnit } from '@rp/contracts'

export const REPLY_LENGTH_WARN_REMAINING = 500
export const REPLY_LENGTH_WARN_SHARE = 0.2

export type ReplyLength = {
  count: number
  limit: number
  unit: ReplyTextUnit
  remaining: number
  nearLimit: boolean
  overLimit: boolean
}

export const warnRemainingFor = (limit: ReplyTextLimit): number =>
  Math.min(REPLY_LENGTH_WARN_REMAINING, Math.floor(limit.max * REPLY_LENGTH_WARN_SHARE))

export const replyLength = (text: string, limit: ReplyTextLimit = COMMENT_TEXT_LIMIT): ReplyLength => {
  const count = measureReplyText(text, limit.unit)
  const remaining = limit.max - count
  return {
    count,
    limit: limit.max,
    unit: limit.unit,
    remaining,
    nearLimit: remaining <= warnRemainingFor(limit),
    overLimit: remaining < 0,
  }
}
